import React from "react";

function SchemaDashboard({ schemaDashboard }) {
  return (
    <div className="row mt-3 g-3">
      {schemaDashboard?.map((card) => (
        <div className="col-lg-4 col-md-6 col-sm-6" key={card.label}>
          <div
            className="border-0 h-100 position-relative"
            style={{
              borderRadius: "16px",
              background: card.gradient,
              boxShadow: `0 4px 20px ${card.glow}`,
              overflow: "hidden",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              cursor: "default",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-6px) scale(1.02)";
              e.currentTarget.style.boxShadow = `0 12px 32px ${card.glow}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow = `0 4px 20px ${card.glow}`;
            }}
          >
            {/* Decorative circle */}
            <div
              style={{
                position: "absolute",
                top: "-20px",
                right: "-20px",
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                background: "rgba(255,255,255,0.08)",
                pointerEvents: "none",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-30px",
                left: "-15px",
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                background: "rgba(255,255,255,0.05)",
                pointerEvents: "none",
              }}
            />

            <div className="p-3 position-relative" style={{ zIndex: 1 }}>
              {/* Header */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center">
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "12px",
                      background: card.iconBg,
                      backdropFilter: "blur(8px)",
                      flexShrink: 0,
                    }}
                  >
                    <i
                      className={card.icon}
                      style={{
                        fontSize: "20px",
                        color: "#fff",
                      }}
                    />
                  </div>
                  <h6
                    className="fw-bold mb-0 ms-3"
                    style={{
                      fontSize: "15px",
                      color: "#fff",
                      letterSpacing: "0.3px",
                    }}
                  >
                    {card.label}
                  </h6>
                </div>
              </div>

              {/* Divider */}
              <div
                style={{
                  height: "1px",
                  background:
                    "linear-gradient(90deg, rgba(255,255,255,0.3) 0%, rgba(255,255,255,0.05) 100%)",
                  marginBottom: "12px",
                }}
              />

              {/* Metrics */}
              <div className="d-flex align-items-center mb-2">
                <i
                  className="bi bi-wallet2 me-2"
                  style={{ color: card.accent, fontSize: "15px" }}
                />
                <span
                  style={{
                    fontSize: "13px",
                    color: "rgba(255,255,255,0.9)",
                    fontWeight: "500",
                  }}
                >
                  {card.spend}
                </span>
              </div>
              <div className="d-flex align-items-center">
                <i
                  className="bi bi-cart-check me-2"
                  style={{ color: card.accent, fontSize: "15px" }}
                />
                <span
                  style={{
                    fontSize: "13px",
                    color: "rgba(255,255,255,0.9)",
                    fontWeight: "500",
                  }}
                >
                  {card.transaction}
                </span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SchemaDashboard;
